[
  {
    "code": "KR-43",
    "name": "Chungcheongbugdo"
  },
  {
    "code": "KR-44",
    "name": "Chungcheongnamdo"
  },
  {
    "code": "KR-28",
    "name": "Inch'on-Kwangyokshi"
  },
  {
    "code": "KR-49",
    "name": "Jejudo"
  },
  {
    "code": "KR-45",
    "name": "Jeonrabugdo"
  },
  {
    "code": "KR-46",
    "name": "Jeonranamdo"
  },
  {
    "code": "KR-42",
    "name": "Kang-won-do"
  },
  {
    "code": "KR-29",
    "name": "Kwangju-Kwangyokshi"
  },
  {
    "code": "KR-41",
    "name": "Kyonggi-do"
  },
  {
    "code": "KR-47",
    "name": "Kyongsangbuk-do"
  },
  {
    "code": "KR-48",
    "name": "Kyongsangnam-do"
  },
  {
    "code": "KR-26",
    "name": "Pusan-Kwangyokshi"
  },
  {
    "code": "KR-11",
    "name": "Seoul-T'ukpyolshi"
  },
  {
    "code": "KR-27",
    "name": "Taegu-Kwangyokshi"
  },
  {
    "code": "KR-30",
    "name": "Taejon-Kwangyokshi"
  },
  {
    "code": "KR-31",
    "name": "Ulsan-Kwangyokshi"
  }
]